import { render, staticRenderFns } from "./ResourcesItem.vue?vue&type=template&id=0f35c448&scoped=true"
import script from "./ResourcesItem.vue?vue&type=script&lang=js"
export * from "./ResourcesItem.vue?vue&type=script&lang=js"
import style0 from "./ResourcesItem.vue?vue&type=style&index=0&id=0f35c448&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f35c448",
  null
  
)

export default component.exports